
export const usePermission = (roles: string[] = []): boolean => {
  const user = JSON.parse(localStorage.getItem('userData')!);

  return roles.some((role: string) => user?.roles.includes(role));
};